import { Chip } from '@mui/material';

/**
 * Helper currency formatter for INR
 */
export const formatINR = (val) => {
    const num = Number(val) || 0;
    return `₹ ${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

/**
 * Helper for Crossbanking Status chip in Balance Adjustments History
 */
export const renderCrossbankingStatusChip = (status) => {
    if (status === null || status === undefined || status === '') {
        return (
            <Chip
                size="small"
                label="N/A"
                sx={{
                    height: 20,
                    fontSize: '0.68rem',
                    fontWeight: 600,
                    bgcolor: '#f1f5f9',
                    color: '#64748b'
                }}
            />
        );
    }

    const s = String(status).trim();
    const lower = s.toLowerCase();

    let bgcolor = '#f1f5f9';
    let color = '#475569';
    let border = '1px solid #e2e8f0';

    if (['success', 'successful', 'completed', 'active', 'true', '1', 'done', 'approved'].includes(lower)) {
        bgcolor = '#f0fdf4';
        color = '#15803d';
        border = '1px solid #bbf7d0';
    } else if (['pending', 'initiated', 'processing', 'in_progress', 'queued', 'waiting'].includes(lower)) {
        bgcolor = '#fffbeb';
        color = '#b45309';
        border = '1px solid #fde68a';
    } else if (['failed', 'failure', 'rejected', 'error', 'declined', 'false', '0'].includes(lower)) {
        bgcolor = '#fef2f2';
        color = '#b91c1c';
        border = '1px solid #fecaca';
    }

    return (
        <Chip
            size="small"
            label={s.toUpperCase()}
            sx={{
                height: 22,
                fontSize: '0.68rem',
                fontWeight: 700,
                bgcolor,
                color,
                border
            }}
        />
    );
};
